import { ReactComponent } from "./ic_routing.svg";

const RoutingIcon = () => <ReactComponent />;

export default RoutingIcon;
